import { Environment } from "./Environment";

// @ts-ignore
const getApiUrl = (defaultUrl: string) => process.env.REACT_APP_GRAPHQL_API || defaultUrl;

export const Configuration = {
  production: {
    sub_domain: "/",
    application_base_url: getApiUrl("https://bolsadetrabajo.fi.uba.ar/graphql"),
    show_seeded_users: false
  },
  staging: {
    sub_domain: "/",
    application_base_url: getApiUrl("http://antiguos.fi.uba.ar/graphql"),
    show_seeded_users: true
  },
  development: {
    sub_domain: "/",
    application_base_url: getApiUrl("http://localhost:5006/graphql"),
    show_seeded_users: true
  },
  test: {
    sub_domain: "/",
    application_base_url: getApiUrl("http://localhost:5006/graphql"),
    show_seeded_users: false
  }
}[Environment.env()];
